export default {
  SYSTEM_TO_DEVICE: "system_to_device",
  DEVICE_TO_SYSTEM: "device_to_system",
  SYSTEM_TO_EXTERNAL: "system_to_external"
};
